import { Option } from "@jutro/types";
import { Button, FiltersIcon, Tabs } from "@jutro/ui";
import { Fragment, useState } from "react";
import { AnimatedHeaderOnScrollWrapper } from "components/AnimatedHeaderOnScrollWrapper";
import { AttendanceTracker } from "views/StaffSchedule/AttendanceTracker";
import { StaffScheduleCreator } from "views/StaffSchedule/StaffScheduleCreator";
import { StaffSettings } from "views/StaffSchedule/StaffSettings";

const options: Option<
  "scheduleCreator" | "attendanceTracker" | "staffSettings"
>[] = [
  {
    value: "scheduleCreator",
    label: "Planowanie",
  },
  {
    value: "attendanceTracker",
    label: "Obecności",
  },
  {
    value: "staffSettings",
    label: "Personel",
  },
];

export const StaffSchedule = () => {
  const [currentTab, setCurrentTab] = useState(options[0].value);

  return (
    <div className="relative flex h-full w-full flex-col rounded-xl bg-white p-3">
      <AnimatedHeaderOnScrollWrapper>
        {({ isScrolled, setIsScrolled, setContainerRef }) => (
          <Fragment>
            <div className="flex items-center justify-between gap-4">
              <div
                className={`flex flex-row gap-2.5 ${isScrolled ? "pb-0" : "pb-4"}`}
              >
                <h1 className="font-heading-1 text-jutro-new-warm-gray-800 pl-1">
                  Planer pracy
                </h1>

                <div className="flex items-center gap-2.5">
                  <Tabs
                    options={options}
                    value={
                      options.find((option) => option.value === currentTab) ?? {
                        value: "scheduleCreator",
                        label: "Planowanie",
                      }
                    }
                    width="hug"
                    onChange={({ value }) => {
                      setIsScrolled(false);
                      setCurrentTab(value);
                    }}
                    backgroundColor="gray"
                    size="condensed"
                  />

                  {isScrolled ? (
                    <Button
                      icon={<FiltersIcon />}
                      size="condensed"
                      label="Pokaż filtry"
                      tooltipPosition="top"
                      variant="secondary"
                      type="button"
                      onClick={() => setIsScrolled(false)}
                    />
                  ) : null}
                </div>
              </div>
            </div>

            <div className="flex h-full min-h-0 flex-col gap-3">
              {currentTab === "scheduleCreator" && (
                <StaffScheduleCreator
                  isScrolled={isScrolled}
                  setContainerRef={setContainerRef}
                />
              )}

              {currentTab === "attendanceTracker" && (
                <AttendanceTracker
                  isScrolled={isScrolled}
                  setContainerRef={setContainerRef}
                />
              )}

              {currentTab === "staffSettings" && (
                <StaffSettings
                  isScrolled={isScrolled}
                  setContainerRef={setContainerRef}
                />
              )}
            </div>
          </Fragment>
        )}
      </AnimatedHeaderOnScrollWrapper>
    </div>
  );
};
